<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1Contact",
  computed: {
    ...mapGetters("bahn1", ["ansprechsperson"]),
    photoUrl() {
      const img = this.ansprechsperson && this.ansprechsperson.Profilbild;
      return img
        ? this.$store.getters.getStrapiImageUrl(img, "thumbnail")
        : require("@/assets/Profile_Placeholder.png");
    }
  }
};
</script>

<template>
  <v-sheet class="contact-box" v-if="ansprechsperson">
    <img :src="photoUrl" width="72px" height="72px" class="contact-photo" />
    <div class="contact-details" style="margin-left: 24px">
      <div class="contact-name">{{ ansprechsperson.VorUndNachname }}</div>
      <div class="contact-title">{{ ansprechsperson.Rolle }}</div>
      <div
        style="display: flex; flex-direction: column; align-items: flex-start;"
        class="mt-2"
      >
        <span class="contact-way-label">
          <a :href="`mailto:${ansprechsperson.Email}`">{{
            ansprechsperson.Email
          }}</a>
        </span>
        <span class="contact-way-label mt-2">
          <a :href="`tel:${ansprechsperson.TelNr}`">{{
            ansprechsperson.TelNr
          }}</a>
        </span>
      </div>
    </div>
  </v-sheet>
</template>

<style scoped>
.contact-box {
  width: 40%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  margin: 24px 16px 80px 0 !important;
}
.contact-details {
  min-width: 0;
}
.contact-photo {
  border-radius: 50%;
  object-fit: cover;
  margin-top: 37px;
  margin-bottom: 37px;
  margin-left: 24px;
}
.contact-name {
  font-size: 16px;
  font-family: "GeometriaGeometria";
}
.contact-title {
  font-size: 14px;
  font-family: "GeometriaLight";
}
.contact-way-label {
  max-width: 100%;
  padding: 0 4px;
  font-size: 14px;
  color: #b40055;
  font-family: "GeometriaLight";
  background: #f8e6ee;
  border-radius: 5px;
  overflow-wrap: anywhere;
}
.contact-way-label a {
  overflow-wrap: anywhere;
}
@media (max-width: 599px) {
  .contact-box {
    width: 100%;
    margin-right: 0 !important;
  }
}
</style>
